'use client'

import { Modal } from '@wiggot/web-components'
import {
  SearchForm,
  GoogleMapsServicesProvider
} from '@wiggot/search-components'
import { ISearchModalResponse } from '@/interfaces'
import { OPERATION_TYPES_DICT } from '@/utils/constants'
import { SEARCH_RESULTS_ROUTE } from '@/utils/routes'

interface SearchByModalProps {
  isOpen: boolean
  onClose: () => void
  variant: string
}

const gmapsApiKey = process.env.GOOGLE_MAPS_API_KEY || ''

export interface ISearchResultsRoute {
  operation: string
  lat: number
  lng: number
  propertyTypes: string[]
  sharesCommission: boolean
  fullAddress: string
  priceTo: number
  searchLevel: string
}

export const SearchByModal = ({
  isOpen,
  onClose,
  variant
}: SearchByModalProps) => {
  const onClickFunc = ({
    maxBudget,
    propertyTypes,
    operationType,
    sharesCommission,
    location
  }: ISearchModalResponse) => {
    window.location.href = SEARCH_RESULTS_ROUTE({
      operation: OPERATION_TYPES_DICT[operationType],
      lat: location.coordinates.lat,
      lng: location.coordinates.lng,
      searchLevel: location.searchLevel,
      propertyTypes,
      sharesCommission,
      fullAddress: location.fullAddress,
      priceTo: maxBudget
    })
  }

  return (
    <>
      <GoogleMapsServicesProvider apiKey={gmapsApiKey} />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOutsideClick={false}
        enableBgBlur
        containerClassName="border-0"
      >
        <SearchForm
          variant={variant}
          onClickFunc={onClickFunc}
          onCloseFunc={onClose}
          isActiveButtonClassName="bg-[#222]"
          formContainerClassName="md:w-[524px]"
          buttonClassName="bg-[#0038FF]"
          ilustrationSubtitleClassName="md:text-base text-xs"
        />
      </Modal>
    </>
  )
}
